module.exports = __webpack_public_path__ + "static/media/plus-deep-blue-outline.04a0524a.svg";